module.exports = __webpack_public_path__ + "school/img/ebooksPrimaryBg.a62d9ccd.jpg";